const getToasEl = type => document.querySelector(`[data-toas-type=${type}]`).innerHTML

window.$toas = {
  show: (id = null, text = null, { left, right, description, onClick, timeout, aligment } = {}) => {
    if (text == null) {
      text = id
      id = 'success'
    }

    let toasBody = getToasEl(id)
    const toasRoot = document.createElement('div')

    if (left) {
      toasBody = toasBody.replace('{left}', left)
    }
    if (right) {
      toasBody = toasBody.replace('{right}', right)
    }
    if (description) {
      toasBody = toasBody.replace('{description}', description)
    }
    toasBody = toasBody.replace('{text}', text)

    toasRoot.classList.add('toas')
    toasRoot.innerHTML = toasBody

    if (!description) {
      toasRoot.querySelector('.description').remove()
    }
    if (!left) {
      toasRoot.querySelector('.left').remove()
    }
    if (!right) {
      toasRoot.querySelector('.right').remove()
    }

    let toasEl
    if (aligment == 'top') {
      toasEl = document.querySelector('#toas-root-top')
    } else {
      toasEl = document.querySelector('#toas-root-bottom')
    }
    toasEl.appendChild(toasRoot)

    if (timeout) {
      setTimeout(() => {
        toasRoot.remove()
      }, timeout)
    } else {
      setTimeout(() => {
        toasRoot.remove()
      }, 5000)
    }

    if (onClick && onClick != 'close') {
      toasRoot.addEventListener('click', () => {
        onClick()
      })
    } else {
      toasRoot.addEventListener('click', () => {
        toasRoot.remove()
      })
    }
  },
}
